import React from "react";
import { useNavigate } from "react-router-dom";
import AppointmentBooking from "../../AppointmentBooking";

/**
 * BookingModalBridge
 *
 * Props:
 * - open: boolean
 * - doctor: object
 * - selectedService: { id, title, price?, duration?, description? } | null
 * - onClose: () => void
 * - onSuccess?: (appointmentId: string) => void
 * - afterSuccessNavigateTo?: string           // e.g. "/dashboard-patient"
 */
const BookingModalBridge = ({
  open,
  doctor,
  selectedService,
  onClose,
  onSuccess,
  afterSuccessNavigateTo,
}) => {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <AppointmentBooking
      doctor={doctor}
      selectedService={selectedService}
      onClose={onClose}
      onSuccess={(appointmentId) => {
        try {
          onSuccess?.(appointmentId);
        } finally {
          if (afterSuccessNavigateTo) navigate(afterSuccessNavigateTo);
        }
      }}
    />
  );
};

export default BookingModalBridge;
